/**
 * One active dispatch (EmployeeJob) for an employee with its current Sparta pay rate next to the
 * Viewpoint default rate for that job, flagging when they differ (WI 32011). A mismatch means the
 * Sparta rate differs from the Viewpoint default; it is not necessarily wrong (ATF / G40 / step-up
 * / rate-sheet rates legitimately sit above the default).
 */
export interface EmployeePayRateDiscrepancy {
  employeeJobID: string;
  jobID: string | null;
  vpJobId: string | null;
  jobName: string | null;
  craft: string | null;
  jobClass: string | null;
  shift: number | null;
  spartaPayRate: number | null;
  viewpointPayRate: number | null;
  isMismatch: boolean;
}

/**
 * Outcome of a bulk cross-job pay-rate update (WI 32011). `updated` rows had their rate changed;
 * `skippedOffTemplate` rows were left unchanged because the new rate is off template and the bulk
 * path cannot document it (WI 30928 regime), so the caller tells the user which rows still need
 * documenting individually on the dispatch Rates tab.
 */
export interface BulkPayRateUpdateResult {
  updated: number;
  skippedOffTemplate: number;
}
